import React, { Component, Fragment } from "react";
import Layout from "../../shared/components/layouts/MainLayout";
import Select from "../../shared/components/forms/Select";

import TradeDocuments from "../containers/TradeDocuments";
import TimedBanner from "../../shared/components/notices/TimedBanner";

import { segmentEventTracker } from "../../../utils/SegmentEventTracker";
import { PageViewName, TrackEventName } from "../../shared/constants/SegmentEvents";

class Applications extends Component {

  constructor(props) {
    super(props);

    this.state = {
      documentType: (props.location.state && props.location.state.docType) || '',
      documentStatus: (props.location.state && props.location.state.status) || '',
      successMessage: (props.location.state && props.location.state.successMessage) || '',
    }
  }

  componentDidMount() {
    segmentEventTracker.trackPageView(PageViewName.APPLICATIONS_VIEWED)
  }

  onChange = (e) => {
    let updatedState = {};
    updatedState[e.target.name] = e.target.value;
    this.setState(updatedState);
  }

  selectOptions = (type) => {
    let documentOptions = {
      d_type: [
        { text: 'Purchase Orders', value: 'PurchaseOrder' },
        { text: 'Invoices',        value: 'Invoice' }
      ],
      d_status: [
        { text: 'Action Required', value: 'action_required' },
        { text: 'In Queue', value: 'in_queue' },
        { text: 'Verifying the document', value: 'verifying_document' },
        { text: 'Verifying Buyer', value: 'verifying_buyer' },
        { text: 'For Final Assessment', value: 'for_final_assessment' },
        { text: 'Loan Offer Sent', value: 'loan_offer_sent' },
        { text: 'Loan Offer Expired', value: 'loan_offer_expired' },
        { text: 'Loan Offer Accepted', value: 'loan_offer_accepted' },
        { text: 'Disbursed', value: 'disbursed' },
        { text: 'Rejected', value: 'rejected' },
        { text: 'Draft', value: 'draft' },
      ]
    }
    return documentOptions[type]
  }

  trackClickEvent = (e = null) => {
    const elementName = e && e.target ? e.target.name : null;

    switch(elementName) {
      case 'documentType':
        segmentEventTracker.trackEvent(TrackEventName.DOC_TYPE_CLICKED);
        break;
      case 'documentStatus':
        segmentEventTracker.trackEvent(TrackEventName.DOC_STATUS_CLICKED);
        break;
      default:
        segmentEventTracker.trackEvent(TrackEventName.TRADE_DOC_VIEW_DETAILS_CLICKED)
        break;
    }
  };

  render() {
    return (
      <Fragment>
        <TimedBanner
          body={this.state.successMessage}
          open={this.state.successMessage.length > 0}
          duration={7}
          className="-success"
        />

      <Layout header="Your Applications" gridClassName='grid --narrow'>
        <div className='ds-card'>
          <section className='cardSection'>
            <div className='_displayFlex'>
              <Select
                label="Type"
                name="documentType"
                value={this.state.documentType}
                options={this.selectOptions('d_type')}
                includeBlank="All Documents"
                onChange={this.onChange}
                onFocus={this.trackClickEvent}
                className="_paddingRight--xxsmall"
              />
              <Select
                label="Status"
                name="documentStatus"
                value={this.state.documentStatus}
                options={this.selectOptions('d_status')}
                includeBlank="All Status"
                onChange={this.onChange}
                onFocus={this.trackClickEvent}
              />
            </div>
          </section>
          <TradeDocuments
            trackClickEvent={this.trackClickEvent}
            documentType={this.state.documentType}
            documentStatus={this.state.documentStatus}
          />
        </div>
      </Layout>
    </Fragment>
    )
  }
}

export default Applications;



// WEBPACK FOOTER //
// ./src/features/trade_documents/components/Applications.js